import React from 'react'
import Bredcom from '../../Bradcom/ServiciosAmenidadesB'
import First from '../../Menservishdeatils/First';
import { Helmet } from "react-helmet-async";

const Main = () => {
  return (
    <>
      <Helmet>
        <title>Hotel La Finca Zotoluca | Servicios y Amenidades</title>
        <meta
          name="description"
          content="El Hotel La Finca es el escenario perfecto para eventos privados, tanto sociales como corporativos."
        />
      </Helmet>
        <main>
            <Bredcom title={"Servicios y Amenidades"} subtitle={"Inicio"} newtitle={"Servicios y Amenidades"} />
            <First/>
        </main>
    </>
  )
}

export default Main